module.exports = __webpack_public_path__ + "img/artfacts.bc9069f1.png";